import Choices from "choices.js";

let element = document.querySelector('#educator_selector');

window.choicesTranslate = function (keyword) {
    let lang = document.querySelector("html").getAttribute("lang");
    if (lang === null) lang = "tr";

    const translations = {
        tr: {
            "Eğitmen seçin": "Eğitmen seçin",
            "Yükleniyor...": "Yükleniyor...",
            "Arama sonucu bulunamadı": "Arama sonucu bulunamadı",
            "Seçecek değer bulunamadı": "Seçecek değer bulunamadı",
            "Seçmek için tıklayın": "Seçmek için tıklayın",
            "Sorumlu seçin": "Sorumlu seçin",
        },
        en: {
            "Eğitmen seçin": "Choose Educator",
            "Yükleniyor...": "Loading...",
            "Arama sonucu bulunamadı": "No results found",
            "Seçecek değer bulunamadı": "No choices to choose from",
            "Seçmek için tıklayın": "Click to select",
            "Sorumlu seçin": "Choose Responsible",
        },
    };

    if (translations[lang][keyword]) {
        return translations[lang][keyword];
    }

    return keyword;
};

if (element) {


    // get current language from html tag lang attribute
    const lang = document.querySelector('html').getAttribute('lang');
    console.log('im here broh.....', lang);

    var multipleFetch = new Choices('#educator_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: choicesTranslate('Eğitmen seçin'),
        removeItemButton: true,
        duplicateItemsAllowed: false,
        loadingText: choicesTranslate('Yükleniyor...'),
        noResultsText: choicesTranslate('Arama sonucu bulunamadı'),
        noChoicesText: choicesTranslate('Seçecek değer bulunamadı'),
        itemSelectText: choicesTranslate('Seçmek için tıklayın'),
    }).setChoices(function() {
        return fetch(
            '/admin/api/educators',
        )
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // Prefer educator IDs that are already selected in the DOM when
                // deduplicating by title — this prevents the same label appearing
                // twice (once as the selected pill from server-rendered option,
                // and once as an unselected dropdown choice with a different id).
                var selectEl = document.querySelector('#educator_selector');
                var selectedValues = [];
                if (selectEl) {
                    for (var i = 0; i < selectEl.options.length; i++) {
                        if (selectEl.options[i].selected) {
                            selectedValues.push(selectEl.options[i].value.toString());
                        }
                    }
                }

                var map = {}; // norm -> educator (prefer selected ids)
                data.forEach(function(educator) {
                    var norm = (educator.title || '').toString().toLowerCase().trim();
                    if (!map[norm]) {
                        map[norm] = educator;
                    } else {
                        // If current educator id is among selected, prefer it
                        if (selectedValues.indexOf(educator.id.toString()) !== -1) {
                            map[norm] = educator;
                        }
                    }
                });

                var unique = Object.keys(map).map(function(k) {
                    return { value: map[k].id, label: map[k].title };
                });

                return unique;
            });
    });

}
let element2 = document.querySelector('#user_selector');

if (element2) {
    // Parse `data-users` attribute (may be JSON or an object-like string)
    const usersAttr = element2.getAttribute('data-users');
    let users = [];
    try {
        users = typeof usersAttr === 'string' ? JSON.parse(usersAttr) : usersAttr;
    } catch (e) {
        try {
            // eslint-disable-next-line no-eval
            users = eval(usersAttr);
        } catch (e2) {
            users = [];
        }
    }

    var multipleFetch = new Choices('#user_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: choicesTranslate('Sorumlu seçin'),
        removeItemButton: true,
        duplicateItemsAllowed: false,
        loadingText: choicesTranslate('Yükleniyor...'),
        noResultsText: choicesTranslate('Arama sonucu bulunamadı'),
        noChoicesText: choicesTranslate('Seçecek değer bulunamadı'),
        itemSelectText: choicesTranslate('Seçmek için tıklayın'),
    }, 'value', 'label', true).setChoices(function() {
        return (users || []).map(function(user) {
            return { value: user.id, label: user.name };
        });
    });
}

// Instructors dropdown toggle (for server-rendered checkbox list)
document.addEventListener('DOMContentLoaded', function () {
    const dropdowns = document.querySelectorAll('[data-instructors-dropdown]');
    dropdowns.forEach(function (wrapper) {
        const btn = wrapper.querySelector('[data-toggle-instructors]');
        const panel = wrapper.querySelector('[data-instructors-panel]');
        if (!btn || !panel) return;

        const updateCount = function () {
            const checked = panel.querySelectorAll('input[type="checkbox"][name="educators[]"]:checked').length;
            const countEl = btn.querySelector('.instructors-count');
            if (countEl) {
                countEl.textContent = checked ? (checked + ' seçili') : '';
            }
            btn.setAttribute('aria-expanded', panel.style.display === 'block' ? 'true' : 'false');
        };

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const isOpen = panel.style.display === 'block';
            panel.style.display = isOpen ? 'none' : 'block';
            btn.setAttribute('aria-expanded', (!isOpen).toString());
        });

        // Close on outside click
        document.addEventListener('click', function (e) {
            if (!wrapper.contains(e.target)) {
                panel.style.display = 'none';
                btn.setAttribute('aria-expanded', 'false');
            }
        });

        // Update count when checkboxes change
        panel.addEventListener('change', function () {
            updateCount();
        });

        // initial
        updateCount();
    });
});
